import { Amplitude } from './amplitude';
import { LogRocketAnalyticsService } from './log-rocket';
import { Segment } from './segment';
import { SentryService } from './sentry';

export const AnalyticsServices = [LogRocketAnalyticsService, Segment, SentryService, Amplitude];
